import React from 'react';
import { Vehicle } from '@esportal/portal-service';
import { hasContract, longdriveProduct } from '../../../helpers/servicesHelper';
import { checkqueoDeCortesiaLayer } from './content-detail-layers/checkeo-de-cortesia';
import { cocheDeSustitucionLayer } from './content-detail-layers/coche-de-sustitucion';
import { expressServiceLayer } from './content-detail-layers/express-service';
import { garantiaVolkswagenLayer } from './content-detail-layers/garantia-volkswagen';
import { idCareLayer } from './content-detail-layers/id-care';
import { itvPorTiLayer } from './content-detail-layers/itv-pot-ti';
import { longDriveAdvanceLayer } from './content-detail-layers/longdrive-advance';
import { longdriveNoContratadoLayer } from './content-detail-layers/longdrive-no-contratado';
import { longDriveNoInformadoLayer } from './content-detail-layers/longdrive-no-informado';
import { longdriveStandardLayer } from './content-detail-layers/longdrive-standard';
import { preItvLayer } from './content-detail-layers/pre-itv';
import { recogidaYentregaLayer } from './content-detail-layers/recogida-y-entrega';
import { serviciosTallerLayer } from './content-detail-layers/servicios-taller';
import { longDriveProLayer } from './content-detail-layers/longdrive-pro';
import { IPortalContext } from '../../../context/portal-context';

export enum ServiceType {
	AsistenciaCarretera = 'asistencia-carretera',
	LongDrive = 'long-drive',
	GarantiaVolkswagen = 'garantia-volkswagen',
	IdCare = 'id-care',
	RecogidaEntrega = 'recogida-entrega',
	CocheSustitucion = 'coche-sustitucion',
	ExpressService = 'express-service',
	Autoservicio = 'autoservicio',
	ITVporTi = 'itv-por-ti',
	CheckeoCortesia = 'checkeo-cortesia',
	PreItv = 'pre-itv',
}

export interface ServiceLayer {
	header: string;
	title: string;
	subtitle: JSX.Element;
	description?: JSX.Element;
	imageContent?: string;
	ctaText?: string;
	link?: string;
	descriptionFooter?: JSX.Element;
	imageFooter?: string;
}

export const defaultServiceLayer: ServiceLayer = {
	header: '',
	title: '',
	subtitle: <></>,
	description: <></>,
};

export const getServiceLayerData = (
	type: ServiceType,
	vehicle: Vehicle,
	portalContext: IPortalContext,
): ServiceLayer => {
	const { userInteractionService } = portalContext;

	switch (type) {
		case ServiceType.AsistenciaCarretera:
			return {
				header: '',
				title: '',
				subtitle: <></>,
			};
		case ServiceType.LongDrive: {
			if (hasContract(vehicle.longdrive?.contractEndDate)) {
				if (longdriveProduct(vehicle) === 'Standard') {
					return longdriveStandardLayer(userInteractionService);
				} else if (longdriveProduct(vehicle) === 'Advance') {
					return longDriveAdvanceLayer(userInteractionService);
				} else if (longdriveProduct(vehicle) === 'Pro') {
					return longDriveProLayer(userInteractionService);
				} else {
					return longDriveNoInformadoLayer;
				}
			} else {
				return longdriveNoContratadoLayer;
			}
		}
		case ServiceType.GarantiaVolkswagen:
			return garantiaVolkswagenLayer(vehicle);

		case ServiceType.IdCare:
			return idCareLayer;

		case ServiceType.RecogidaEntrega:
			return recogidaYentregaLayer;

		case ServiceType.CocheSustitucion:
			return cocheDeSustitucionLayer;

		case ServiceType.ExpressService:
			return expressServiceLayer;

		case ServiceType.Autoservicio:
			return serviciosTallerLayer;

		case ServiceType.ITVporTi:
			return itvPorTiLayer;

		case ServiceType.CheckeoCortesia:
			return checkqueoDeCortesiaLayer;

		case ServiceType.PreItv:
			return preItvLayer;

		default:
			return defaultServiceLayer;
	}
};
